const module = { name: 'movie/shared/details', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes } from 'require-global';

const { EventTypes } = Fandango_adobeLaunch_EventTypes;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango as Fandango } from 'require-core';



const { movieDetails } = Fandango


import { default as Fandango_triggerEvent_triggerAnalyticsEvent_isMobile } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent, isMobile } = Fandango_triggerEvent_triggerAnalyticsEvent_isMobile;


const Selectors = {
    MORE_BTN: '.movie-detail-header__info-link',
    WATCH_VIDEO_LINK: '.js-movie-detail-watch-videos',
    MOVIE_DETAIL_DROPDOWN: '#movie-detail-dropdown'
}
function onMoreBtnClick(e) {
    e.preventDefault();
    const $dropdown = $(Selectors.MOVIE_DETAIL_DROPDOWN);
    if ($dropdown.length) {
        if (isMobile) {
            let headerOffset = 50;
            if ($('body').hasClass('body--cobranding')) {
                headerOffset += 30;
            }
            const elementPosition = $dropdown.offset().top;
            const offsetPosition = elementPosition - headerOffset;
            window.scrollTo(0, offsetPosition);
        }
        else {
            const elementPosition = $dropdown.offset().top;
            const offsetPosition = elementPosition - 20;
            window.scrollTo(0, offsetPosition);
        }
    }
    $(Selectors.WATCH_VIDEO_LINK).trigger('focus');
    const { id: movieID, offer, title: movieName, genre: movieGenre, releaseDate, formatSelected, dateSelected } = movieDetails;
    triggerAnalyticsEvent(EventTypes.PAGE_VIEW, {
        pageType: 'mop details',
        pageName: `movie | overview | ${movieName} | details`,
        movieName,
        movieGenre,
        movieID,
        platform: isMobile ? 'fandango mobile web' : 'fandango web',
        offersWithPurchase: offer && [{
                offerId: offer.id,
                offerLabel: offer.label
            }],
        dateSelected,
        formatSelected,
        releaseDate,
    });
}
function onWatchVideosClick() {
    triggerAnalyticsEvent(EventTypes.WATCH_VIDEOS_CLICKS, {
        event: EventTypes.WATCH_VIDEOS_CLICKS
    });
}
function attach() {
    $(Selectors.WATCH_VIDEO_LINK).on('click', onWatchVideosClick);
    $(Selectors.MORE_BTN).on('click', onMoreBtnClick);
}
module.exports = {
    attach,
};
export default module.exports;